module.exports = __webpack_public_path__ + "img/multi-options.bcc04fe9.svg";